// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NSmy","left":"styles_left__Yuky0"};